import { fetchJsonWithRetries } from './api/fetchHelpers';
import { BrandParentUrl } from './types';

export interface MsalConfig {
    azureTenantId: string;
    applicationId: string;
}

export interface Genesys {
    [key: string]: GenesysTenant;
}

export interface GenesysTenant {
    authorizeGenesysUrl: string;
    authorizeTokenUrl: string;
    authorizeWebviewUrl: string;
    genesysApiEndpoint: string;
    genesysClientId: string;
}

export type Tier = 'local' | 'dev' | 'stage' | 'prod';
export interface Config {
    tier: Tier;
    authServiceEndpoint: string;
    ehrServiceEndpoint: string;
    amplitudeReverseProxyEndpoint: string;
    amplitudeAnalyticsKey: string;
    amplitudeDeploymentKey: string;
    userInfoForAnalytics: string;
    validTokenOriginList: string[];
    mychartDomains?: string[];
    msalConfig?: MsalConfig;
    appInsightsKey: string;
    validTranscriptExportOriginList: string[];
    brandParentUrl: BrandParentUrl;
    genesys: Genesys;
}

export const fetchConfig = async (): Promise<Config> => {
    return await fetchJsonWithRetries({
        input: '/config/client/config.json',
        maxRetries: 3,
    });
};

function getCookie(name: string): string | undefined {
    const match = document.cookie.match(new RegExp(name + '=([^;]+)'));
    return match ? match[1] : undefined;
}

export const needAAD = (tier: Tier, msalConfig?: MsalConfig): boolean => {
    // This allows our automated test execution to bypass auth by setting a cookie
    if ('one' === getCookie('test')) {
        return false;
    }
    return tier === 'dev' && !!msalConfig;
};
